// @ts-nocheck
import { useState, useEffect } from 'react';
import { getMachinesByLocation } from '../services/supabaseService';

export const useMachinesByLocation = (location: string) => {
    const [machines, setMachines] = useState([]);

    useEffect(() => {
        const fetchMachines = async () => {
            try {
                if (location) {
                    const machinesData = await getMachinesByLocation(location);
                    // Ensure each machine has id and name properties
                    const formattedMachines = machinesData.map(machine => ({
                        id: machine.id,
                        name: machine.name || machine.id
                    }));
                    setMachines(formattedMachines);
                } else {
                    setMachines([]);
                }
            } catch (error) {
                console.error("Failed to fetch machines:", error);
                setMachines([]);
            }
        };

        fetchMachines();
    }, [location]);

    return machines;
};

export default useMachinesByLocation; 